import React, { useEffect, useState } from "react";
import { TikTokEmbedPlayer } from "../TikTokEmbedPlayer/TikTokEmbedPlayer";
import { Img } from "../Img/Img";

interface Props {
  url: string;
  fallbackImageSrc: string;
}

export const TikTokVideo = (props: Props) => {
  const { url, fallbackImageSrc } = props;

  const [videoExists, setVideoExists] = useState(false);
  const [loadComplete, setLoadComplete] = useState(false);

  useEffect(() => {
    setLoadComplete(false);
    setVideoExists(false);

    const checkVideoExists = async () => {
      try {
        const response = await fetch(
          `https://www.tiktok.com/oembed?url=${url}`,
        );
        if (response.ok) {
          setVideoExists(true);
        }
      } catch (error) {
        console.error("Error checking video existence:", error);
      } finally {
        setLoadComplete(true);
      }
    };

    checkVideoExists();
  }, [url]);

  if (!loadComplete) return null;

  if (videoExists) {
    return <TikTokEmbedPlayer url={url} />;
  }

  return (
    <Img
      src={url}
      fallbackImageSrc={fallbackImageSrc}
      referrerPolicy="no-referrer"
    />
  );
};
